import React from "react";
import "../App.css";

const StartMenu = ({ handleStart, handleNavigateToMatchingQuestion, reviewerType }) => {
    return (
        <>
            <h3>Choose Question Type</h3>
            {
                reviewerType === "SuiteFoundation" ?
                    <div className="start-menu">
                        <button className="start-button" onClick={() => handleStart(65)}>65 Questions - Multiple Choice<br/>(Timed)</button>
                        <br />
                        <button className="start-button" onClick={() => handleStart("all")}>All Questions - Multiple Choice<br/>(No Time Limit)</button>
                        <br />
                        <button className="start-button" onClick={handleNavigateToMatchingQuestion}>Matching Questions<br/>(No Time Limit)</button>
                    </div>
                    :
                    reviewerType === "Application Developer" ?
                        <div className="start-menu">
                            <button className="start-button" onClick={() => handleStart(60)}>Multiple Choice<br/>(Timed)</button>
                            <br />
                            <button className="start-button" onClick={() => handleStart("all")}>Multiple Choice<br/>(No Time Limit)</button>
                        </div>
                        :
                        reviewerType === "Application Developer (AI Generated)" ?
                            <div className="start-menu">
                                <button className="start-button" onClick={() => handleStart(60)}>60 Questions - Multiple Choice<br/>(Timed)</button>
                                <br />
                                <button className="start-button" onClick={() => handleStart("all")}>100 Questions - Multiple Choice<br/>(No Time Limit)</button>
                            </div>
                            :
                            null
                            // SuiteFoundation: 65 Questions - 80-90 Minutes
                            // Application Developer: 60 Questions - 90 Minutes
                            // Web Services Developer: 45 Questions - 90 Minutes
            }

        </>
    );
};

export default StartMenu;